// src/services/cdrService.js
import axios from 'axios'
import store from '@/store'
import { mapCdrRow } from '@/utils/cdrUtils'

export function getCdrEndpoint(scope = 'customer') {
  return scope === 'user' ? '/cdr/user' : '/cdr/customer'
}

export async function fetchCdr({ scope = 'customer', page = 1, per_page = 25, q, date_from, date_to, ...extra } = {}) {
  const params = {
    page,
    per_page,
    q: q || undefined,
    date_from: date_from || undefined,
    date_to: date_to || undefined,
    tz: store.state.auth.timezone || undefined,
    ...extra
  }

  const res = await axios.get(getCdrEndpoint(scope), { params })

  // Expecting:
  // { data: [...], meta: { page, per_page, total, total_pages } }
  const raw = res?.data?.data || []
  const meta = res?.data?.meta || {}

  return {
    data: raw,
    meta: {
      page: Number(meta.page || page),
      per_page: Number(meta.per_page || per_page),
      total: Number(meta.total || 0),
      total_pages: Number(meta.total_pages || 1)
    }
  }
}
